var _style, _filter, _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWorld(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "45 -45.2 210 210.2",
    style: {
      enableBackground: "new 45 -45.2 210 210.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{filter:url(#filter-2);}\n\t.st1{fill:#00BAFF;}\n\t.st2{fill:url(#SVGID_1_);}\n")), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    height: "200%",
    width: "200%",
    filterUnits: "userSpaceOnUse",
    y: "-50%",
    id: "filter-2",
    x: "-50%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 0,
    dx: 0,
    result: "shadow-1-feOffset-shadow",
    in: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30,
    result: "shadow-1-feGaussianBlur-shadow",
    in: "shadow-1-feOffset-shadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0.7333333333333333  0 0 0 0 1  0 0 0 0.5 0",
    result: "shadow-1-feColorMatrix-shadow",
    in: "shadow-1-feGaussianBlur-shadow"
  }))), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1_1_",
    x: 105.4,
    y: 8.4,
    width: 90,
    height: 90.2
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M150.4,8.4c-24.9,0-45,20.2-45,45s20.2,45,45,45c13.4,0,25.5-5.9,33.8-15.3v6.2h9V67h-22.5v9h7.9 c-4.2,5.2-9.8,9.3-16.3,11.5c3.4-7.3,5.7-17.8,6.1-29.5h17.8h8.7h0.4c0.1-1.5,0.2-3,0.2-4.5C195.4,28.6,175.3,8.4,150.4,8.4z  M178.6,31H166c-1-4.4-2.3-8.3-3.8-11.6C168.7,21.7,174.4,25.7,178.6,31z M114.7,57.9h17.8c0.1,3.1,0.4,6.1,0.7,9H117 C115.9,64.1,115.1,61.1,114.7,57.9z M114.7,48.9c0.4-3.1,1.2-6.1,2.3-9h16.2c-0.4,2.9-0.6,5.9-0.7,9H114.7z M142.1,40h16.7 c0.3,2.8,0.5,5.8,0.6,9h-17.9C141.6,45.8,141.8,42.8,142.1,40z M143.4,31c1.6-8.3,4.2-13.5,7-13.5c2.8,0,5.4,5.3,7,13.5H143.4z  M138.6,19.4c-1.5,3.3-2.8,7.2-3.8,11.6h-12.5C126.5,25.7,132.1,21.7,138.6,19.4z M122.3,76h12.5c1,4.3,2.3,8.2,3.8,11.5 C132.2,85.2,126.5,81.2,122.3,76z M143.4,76h14c-1.7,8.2-4.2,13.5-7,13.5C147.6,89.5,145,84.2,143.4,76z M158.8,67h-16.7 c-0.3-2.8-0.5-5.9-0.6-9h17.9C159.3,61.1,159.1,64.1,158.8,67z M168.3,48.9c-0.1-3.1-0.4-6.1-0.7-9h16.2c1.1,2.8,1.9,5.8,2.3,9 H168.3z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 150.7233,
    y1: 87.483,
    x2: 184.4842,
    y2: 87.483
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    style: {
      stopColor: "#00BAFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#004DFF"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M184.5,76.2h-5.7c-4.2,5.2-9.8,9.3-16.3,11.5c-3.2,6.8-7.3,11-11.8,11c13.4,0,25.5-5.9,33.8-15.3V76.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorld);
export default __webpack_public_path__ + "static/media/world.9fe0099e0504790af769587519d3ecef.svg";
export { ForwardRef as ReactComponent };